const styles = {    
    cardHeaderVenda: {
        background:'#427d98',borderRadius:'5px',height:'80px'
    }, 
    titlenew:{
        color:'white',fontSize:'23px',marginTop:'15px'
    },
    boxCar:{
        width:'50px',height:'50px',float:'right', 
        position:'relative',marginRight:'0px',marginTop:'0px'
    },
    icoCar:{
        color:'white',fontSize:'45px',marginTop:'5px'
    },
    notificationCar:{
        background:'#124258',width:'20px',height:'20px',borderRadius:'50px',
        color:'white',fontSize:'10px',textAlign:'center',fontWeight:'bold',
        position:'absolute',top:'2px',right:'15px'
    }
}
  
export default styles;